import { trpc } from '@/lib/trpc';

const useGetUser = () => {
	const { data, isLoading, error, failureReason } = trpc.user.get.useQuery(
		undefined,
		{ retry: 1 }
	);

	const isUnauthorized = failureReason?.data?.code === 'UNAUTHORIZED';

	return {
		user: !isUnauthorized ? data?.user : null,
		userLoading: isLoading,
		userError: error,
	};
};
export default useGetUser;
